import React, {memo} from 'react'

import {resolveHelpURL} from '../../../../../../utils/url'
import HelpLink from '../../../../../common/HelpLink/HelpLink'
import IconButton from '../../../../../common/IconButton/IconButton'

function EnviromentDescriptionComponent() {
  return (
    <>
      {
        'Values used in environments of processes launched by build steps (runners). Skip the "env." prefix when referencing these values by variable names.'
      }
      <HelpLink
        url={resolveHelpURL('configuring-build-parameters.html#Environment+Variables')}
        Component={IconButton}
        icon="help"
        preservePlus
      />
    </>
  )
}

export const EnviromentDescription = memo(EnviromentDescriptionComponent)
